










import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'

@Component({
  inject: ['form'],
})
export default class UnifyListItem extends Vue {
  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop()
  public readonly hideBorder?: any

  public readonly form!: FormGroup<any>

  public get field() {
    return this.form.field(this.control)
  }

  public get showBorder() {
    return this.hideBorder === undefined
  }

  public get invalid() {
    return this.field.$invalid
  }

  public get required() {
    return this.field.hasOwnProperty('required')
  }

  public provide() {
    return {
      formControl: this.control,
    }
  }
}
